// src/components/NotificationDialog.js
import React from 'react';

const NotificationDialog = ({ onAllow, onDeny, couponCodeExists }) => {
  const title = "Stay Updated!";
  let message = "Enable notifications to stay updated on your order status and receive special offers.";

  if (couponCodeExists) {
    message = "Enable notifications to receive a special welcome coupon and updates on your order!";
  }

  return (
    <div className="dialog-overlay">
      <div className="modal-content" style={{ maxWidth: '400px', padding: '30px' }}>
        <div style={{ textAlign: 'center' }}>
          {/* Icon */}
          <div style={{ fontSize: '3em', color: 'var(--primary-orange)', marginBottom: '15px' }}>
            <i className="fas fa-bell"></i>
          </div>

          {/* Text Content */}
          <h3 style={{ margin: '0 0 10px 0' }}>{title}</h3>
          <p style={{ color: 'var(--text-color-secondary)', lineHeight: '1.5' }}>{message}</p>

          {/* Coupon Highlight */}
          {couponCodeExists && (
            <div style={{ 
              backgroundColor: 'var(--light-orange)', 
              color: 'var(--tag-text-color)', 
              padding: '10px', 
              borderRadius: 'var(--border-radius-sm)', 
              marginTop: '15px',
              fontWeight: '500',
              fontSize: '0.9em'
            }}>
              <i className="fas fa-gift" style={{ marginRight: '8px' }}></i>
              You'll receive a special coupon after allowing notifications!
            </div>
          )}

          {/* Action Buttons */}
          <div style={{ marginTop: '25px', display: 'flex', gap: '15px', justifyContent: 'center' }}>
            <button 
              onClick={onAllow} 
              className="admin-btn" 
              style={{ 
                backgroundColor: 'var(--primary-orange)', 
                color: 'white', 
                flex: 1, 
                margin: 0,
                padding: '12px',
                borderRadius: 'var(--border-radius-md)'
              }}
            >
              Allow
            </button>
            <button 
              onClick={onDeny} 
              className="admin-btn" 
              style={{ 
                backgroundColor: 'var(--header-actions-bg)', 
                color: 'var(--text-color)', 
                flex: 1, 
                margin: 0,
                padding: '12px',
                borderRadius: 'var(--border-radius-md)'
              }}
            >
              No, thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationDialog;
